import { UIText1, Image, OnboardingTooltip } from '@cian/ui-kit';
import { IconSocialLikeOff16, IconSocialLikeOn16 } from '@cian/ui-kit-design-tokens/icons';
import classNames from 'clsx';
import * as React from 'react';

import { TChatbotReaction } from '../../../../../../types/chatbot';
import { TExpertButtonContent } from '../../../../../../types/expertButtonContent';

import * as styles from './ExpertButton.css';

import avatar from './assets/avatar.png';

type TExpertButtonProps = {
  expertButtonContent: TExpertButtonContent | null;
  visibleTooltip: boolean;
  tooltipPortal: React.RefObject<HTMLDivElement | null>;
  setCloseTooltip(): void;
  onExpertButton(): void;
  onLike(): void;
  reaction?: TChatbotReaction;
  disabled: boolean;
};

export const ExpertButton: React.FC<TExpertButtonProps> = ({
  expertButtonContent,
  visibleTooltip,
  tooltipPortal,
  setCloseTooltip,
  onExpertButton,
  onLike,
  reaction,
  disabled,
}) => (
  <div className={styles['chatbot-button-container']}>
    <OnboardingTooltip
      open={visibleTooltip}
      portalElement={tooltipPortal.current}
      placement="bottom-start"
      theme="blue"
      onClose={() => setCloseTooltip()}
      content={
        <div className={styles['tooltip-content']}>
          <img className={styles['tooltip-image']} src={avatar} alt="Фото" data-testid="tooltip-image" />
          <span>Попросите помощника кратко описать объект</span>
        </div>
      }
    >
      <button
        type="button"
        className={classNames(styles['chatbot-button'], disabled && styles['chatbot-button--disabled'])}
        onClick={onExpertButton}
        disabled={disabled}
      >
        <Image width={16} height={16} objectFit="cover" src={avatar} data-testid="image" />
        <UIText1 color="text-main-default">{expertButtonContent?.title}</UIText1>
      </button>
    </OnboardingTooltip>
    <div className={styles['like-button']} onClick={onLike}>
      {reaction === 'like' ? (
        <IconSocialLikeOn16 color="icon-main-default" />
      ) : (
        <IconSocialLikeOff16 color="icon-main-default" />
      )}
    </div>
  </div>
);
